// 1_utils/go_top_btn.js
// Exposes window.NAT.utils.goTopBtn(): wires the .goToTop__button to smooth-scroll
// the page to the top. Self-runs once on DOMContentLoaded (as the old code did);
// the Raventic search-results module also calls it after injecting its own
// goToTop button. NOTE: not idempotent — each call adds another click listener.

window.NAT = window.NAT || {};
window.NAT.utils = window.NAT.utils || {};

window.NAT.utils.goTopBtn = function () {
	const goTopBtn = document.querySelector(".goToTop__button");
	if (!goTopBtn) return;

	goTopBtn.addEventListener("click", (e) => {
		e.preventDefault();
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	});
};

document.addEventListener("DOMContentLoaded", function () {
	window.NAT.utils.goTopBtn();
});
